module.exports = __webpack_public_path__ + "media/partners/ogilvy-99de3147.png";